import { Button, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import DatesPicker from 'src/components/mui/datespicker';
import { boxStyle, MenuFilter, menuStyle } from './MenuStyle';
import moment from 'moment';

const MenuSpec = props => {
    const { setFilters, setReload } = props;

    const bizTypes = ['국가연구소', '제조업', '학교', '도소매'];

    const [ranges, setRanges] = useState('def');
    const [checkedBizType, setCheckedBizType] = useState(bizTypes);
    const [keydate, setKeyDate] = useState('spec_time');
    const [daterange, setDateRange] = useState({});
    const [keyword, setKeyword] = useState('orderid');
    const [q, setQ] = useState('');

    useEffect(() => {
        setFilters({
            order_status: '신규견적',
            business_type: checkedBizType.join(','),
            keydate: keydate,            
            startDate: daterange.startdate? moment(daterange.startdate).format('YYYY-MM-DD 00:00:00'): '',
            endDate: daterange.enddate? moment(daterange.enddate).format('YYYY-MM-DD 23:59:59'): '',
            keyword: keyword,
            q: q,
        });
    }, [checkedBizType, keydate, daterange, keyword, q]);

    const handleRange = e => {
        setRanges(e.target.dataset.range);
    };

    return (
        <div style={boxStyle}>
            <MenuFilter title={'업종'} items={bizTypes} checkedItems={checkedBizType} setCheckedItems={setCheckedBizType} />
            <div style={menuStyle}>
                <h5 style={{ width: '5rem', minWidth: '4rem' }}>검색날짜</h5>
                <Select
                    labelId="target-select-date"
                    id="select-date"
                    value={keydate}
                    onChange={(e) => setKeyDate(e.target.value)}
                    sx={{ minWidth: 120, marginRight: '1rem' }}
                    size='small' >
                        <MenuItem value="spec_time">견적일자</MenuItem>
                </Select>
                <Stack direction="row" spacing={2}>
                    <Button variant="outlined" data-range="today" onClick={handleRange}>오늘</Button>
                    <Button variant="outlined" data-range="yesterday" onClick={handleRange}>어제</Button>
                    <Button variant="outlined" data-range="thisweek" onClick={handleRange}>이번주</Button>
                    <Button variant="outlined" data-range="thismonth" onClick={handleRange}>이번달</Button>
                    <Button variant="outlined" data-range="lastweek" onClick={handleRange}>지난주</Button>
                    <Button variant="outlined" data-range="lastmonth" onClick={handleRange}>지난달</Button>
                    <DatesPicker daterange={daterange} setDateRange={setDateRange} ranges={ranges} size='small' />
                </Stack>
            </div>
            <div style={menuStyle}>
                <h5 style={{ width: '5rem', minWidth: '4rem' }}>검색어</h5>
                <Select
                    labelId="target-select-item"
                    id="select-item"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    sx={{ minWidth: 120 }}
                    size='small' >
                        <MenuItem value="orderid">견적번호</MenuItem>
                        <MenuItem value="user_id">회원ID</MenuItem>
                        <MenuItem value="company_name">회사명</MenuItem>
                        <MenuItem value="orderer">주문자</MenuItem>
                        <MenuItem value="catalog_no">Cat No</MenuItem>
                        <MenuItem value="product_name">상품명</MenuItem>
                        <MenuItem value="cas_number">CAS</MenuItem>
                </Select>
                <TextField
                    value={q}
                    label='검색어'
                    id='search'
                    onChange={(e) => setQ(e.target.value)}
                    placeholder='검색어를 입력해주세요'
                    size='small'
                    sx={{ minWidth: 200, marginLeft: '1rem' }}
                />
                <Button variant="contained" onClick={() => setReload(reload => reload+1)} sx={{ marginLeft: '1rem' }}>검색</Button>
            </div>
        </div>
    )
}

export default MenuSpec